/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

type OptionItem = { label: string; value: string };

type ManagerAutocompleteNewProps = {
  value: string;
  label: string;
  onSelect: (option: OptionItem | null) => void;
};

const ManagerAutocompleteNew: FC<ManagerAutocompleteNewProps> = ({
  value,
  label,
  onSelect,
}) => {
  const [valueItem, setValueItem] = useState<OptionItem | null>(null);
  const [options, setOptions] = useState<OptionItem[]>([]);
  const [optionsLoading, setOptionsLoading] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const fetchWorkers = async () => {
      try {
        setOptionsLoading(true);
        const res = await apiClient.get("/data/GetHandbook", {
          params: { type: "workers" },
        });
        const workers = res.data.select
          .sort((a: any, b: any) => a.title.localeCompare(b.title))
          .map((item: any) => {
            const parts = item.title.split("|");
            return { label: parts[0], value: String(item.id) };
          });
        setOptions(workers);
        if (value) {
          setValueItem(
            workers.find((o: any) => o.value === String(value)) || null,
          );
        }
      } catch (error) {
        console.error("Ошибка получения списка менеджеров:", error);
      } finally {
        setOptionsLoading(false);
      }
    };
    fetchWorkers();
  }, []);

  useEffect(() => {
    if (value && options?.length) {
      const found = options.find((o) => o.value === String(value)) || null;
      setValueItem(found);
    }
  }, [value, options]);

  useEffect(() => {
    onSelect(valueItem);
  }, [valueItem]);

  return (
    <Autocomplete<OptionItem, false, false, false>
      value={valueItem}
      onChange={(_, newValue) => {
        setValueItem(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => {
        setInputValue(newInputValue);
      }}
      id="manager-autocomplete"
      options={options}
      getOptionLabel={(option) => option.label}
      getOptionKey={(option) => option.value}
      loading={optionsLoading}
      fullWidth
      autoHighlight
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {optionsLoading ? <CircularProgress size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            },
          }}
        />
      )}
    />
  );
};

export default ManagerAutocompleteNew;
